import { ProjectModel } from "@/models/ProjectModel";
import { ComputedRef, InjectionKey, Ref } from "vue";

export const projectInjectKey = Symbol.for("project") as InjectionKey<ComputedRef<ProjectModel> | Ref<ProjectModel>>;
